export const GET_HONEY_OFFER_DETAILS = `query getHoneyOfferDetails($honeyOfferId: String, $honeyStoreId: String) {
  uiShopping {
    offers(
      input: {
        honeyOfferId: $honeyOfferId,
        honeyStoreId: $honeyStoreId
      }) {
        items {
          ...ItemFragment
          offerType
          redemptionChannels
          title
          description
          storeIds
          details {
            title
            content
          }
          termsAndConditionsSection {
            title
            content
          }
          couponCodeSection {
            title
            content
          }
          howToUseSection {
            title
            content
          }
          conditions {
            image {
              ...ImageFragment
            }
            content
          }
          shoppingCategories
          primaryImage {
            ...ImageFragment
          }
          landingUrl
          savedToWallet
          savedToWallet
          textColor
          backgroundColor
        }
      }
    }
}
fragment ActionsFragment on UI_Shopping_Action {
  type
  title
  navigationType
  navigationTarget
}
fragment ImageFragment on UI_Shopping_Image {
  accessibilityLabel
  url
  name
  backgroundColor
}
fragment TagsFragment on UI_Shopping_Tag {
  text
  type
}
fragment TrackingDetailsFragment on UI_Shopping_TrackingDetails {
  clickUrl
  dismissUrl
  impressionUrl
  presentmentUrl
}
fragment ItemFragment on UI_Shopping_Item {
  itemId
  itemType
  rank
  title
  subtitle
  description
  shoppingCategories
  decryptedOfferProgramId
  encryptedOfferProgramId
  primaryImage {
    ...ImageFragment
  }
  secondaryImage {
    ...ImageFragment
  }
  storeIds
  tags {
    ...TagsFragment
  }
  actions {
    ...ActionsFragment
  }
  textColor
  backgroundColor
  totalItems
  trackingDetails {
    ...TrackingDetailsFragment
  }
}
`
